import angular from 'angular'
import uiRouter from 'angular-ui-router'
import oauthCallback from './components/oauthCallback.component'
import oauthConfigProvider from './providers/oauthConfig.provider'
import OAuthUserService from './services/oauthUser.service';
import tokenService from './services/token.service'

import uiRouterInterceptor from './interceptors/uiRouterInterceptor.run'
import tokenInterceptor from './interceptors/token.interceptor'
import tokenParamInterceptor from './interceptors/tokenParam.interceptor'

export default angular.module("opileak.oauth", [uiRouter])
.component("oauthCallback", oauthCallback)
.provider("oauthConfig", oauthConfigProvider)
.service("tokenService", tokenService)
.service("OAuthUserService", OAuthUserService)
.factory("tokenInjector", tokenInterceptor)
.factory("tokenParamInjector", tokenParamInterceptor)
.config(($stateProvider) => {
  "ngInject";
  $stateProvider.state({
    name: 'oauth_callback',
    url: '/oauth_callback?access_token&token_type&state&expires_in&scope&jti&user_show_name',
    component: 'oauthCallback'
  })
})
.run(uiRouterInterceptor)
.name



// WEBPACK FOOTER //
// ./src/index.module.js